import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Lazy initialization to avoid TDZ issues on iOS
let _supabase: SupabaseClient | null = null;

function getSupabaseInstance(): SupabaseClient {
  if (!_supabase) {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

    _supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
      }
    });
  }
  return _supabase;
}

// Use a Proxy to maintain backward compatibility
export const supabase = new Proxy({} as SupabaseClient, {
  get(_, prop) {
    return Reflect.get(getSupabaseInstance(), prop);
  }
});
